import request from "../utils/request";

export function getCaptcha() {
  return request({
    url: "/common/captcha",
    method: "GET",
    responseType: "blob",
  });
}
export function findPassword(email, captcha) {
  return request({
    url: "/common/forgetPassword/email",
    method: "POST",
    data: {
      email,
      captcha,
    },
  });
}

export function resetPassword(captcha, password) {
  return request({
    url: "/common/password/reset",
    method: "POST",
    data: {
      // email,
      captcha,
      password,
    },
  });
}
